module.exports = __webpack_public_path__ + "assets/img/Striver-Careers-Landing-Page-w960.d7e834c7.webp";